import { TFunction } from 'i18next';
import { IColumn } from 'interfaces';

const getColumns = (t: TFunction): IColumn[] => {
  return [
    {
      title: t('Users.table.name'),
      dataIndex: 'first_name',
      key: 'first_name',
      width: '30%',
      ellipsis: true,
    },
    {
      title: t('login.email'),
      dataIndex: 'email',
      key: 'email',
      width: '35%',
      ellipsis: true,
    },
    {
      title: t('Users.HelperMenu.groupname'),
      dataIndex: 'role',
      key: 'role',
      width: '35%',
      ellipsis: true,
    },
  ];
};

export default getColumns;
